import globals from '@descope-ui/theme-globals';
import { getThemeRefs, useVar } from '@descope-ui/common/theme-helpers';
import { EnrichedTextClass } from './component/EnrichedTextClass';
import { vars as textCompVars } from '@descope-ui/descope-text/theme';
import { vars as linkCompVars } from '@descope-ui/descope-link/theme';

const globalRefs = getThemeRefs(globals);
const vars = EnrichedTextClass.cssVarList;

const enrichedText = {
  [vars.hostDirection]: globalRefs.direction,
  [vars.hostWidth]: useVar(textCompVars.hostWidth),

  [vars.textLineHeight]: useVar(textCompVars.textLineHeight),
  [vars.textColor]: useVar(textCompVars.textColor),
  [vars.textAlign]: useVar(textCompVars.textAlign),

  [vars.fontSize]: useVar(textCompVars.fontSize),
  [vars.fontWeight]: useVar(textCompVars.fontWeight),
  [vars.fontFamily]: useVar(textCompVars.fontFamily),

  [vars.linkColor]: useVar(linkCompVars.textColor),
  [vars.linkTextDecoration]: 'none',
  [vars.linkHoverTextDecoration]: 'underline',

  [vars.fontWeightBold]: '900',
  [vars.minWidth]: '0.25em',
  [vars.minHeight]: '1.35em',

  [vars.hostDisplay]: 'inline-block',

  _empty: {
    _hideWhenEmpty: {
      [vars.hostDisplay]: 'none',
    },
  },
};

export default enrichedText;
export { vars };
